// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"FullWidth-module--fullWidth--3prxQ"};